import React from "react"
import { getDecimalFormat } from "helpers/getNumberFormats"
import { inventoryDictionary } from "helpers/dictionary"
import { UpdatePercentageComponent } from "./UpdatePercentageComponent"
import { InventoriesActions } from "./InventoriesActions"

export const columnsStation_actual = [
  {
    Header: 'Unidad',
    accessor: 'number',
    filterable: true,
    filterMethod: (filter, row) => row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
    // Cell: () => {}
  },
  {
    Header: 'Volumen Total',
    Cell: ({ original }) => {
      const totalVolume = parseFloat(original.totalVolume);
      return (<div>{getDecimalFormat(totalVolume)} lts</div>);
    }
  },
  {
    Header: 'Volumen Actual',
    Cell: ({ original }) => {
      const currentVolume = parseFloat(original.currentVolume);
      return (<div>{getDecimalFormat(currentVolume)} lts</div>);
    }
  },
  {
    Header: 'Porcentaje Fisico',
    Cell: ({ original }) => (<UpdatePercentageComponent data={original} keyInventory={inventoryDictionary.stationary} />)
  },
  {
    Header: 'Total KG',
    Cell: ({ original }) => {
      return (
        <div style={{ float: 'right', marginRight: 16 }}>
          {original.totalKg !== undefined && (original.totalKg !== 0)
            ? getDecimalFormat(original?.totalKg)
            : "0.00"}{" "}
          kg
        </div>
      )
    }
  },
]

export const columnsStation_actual_tanks = [
  {
    Header: 'Tanque',
    accessor: 'number',
    filterable: true,
    filterMethod: (filter, row) => row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
    // Cell: () => {}
  },
  {
    Header: 'Unidad',
    accessor: 'unitNumber',
    filterable: true,
    filterMethod: (filter, row) => row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
    // Cell: () => {}
  },
  {
    Header: 'Volumen Total',
    Cell: ({ original }) => {
      const totalVolume = parseFloat(original.totalVolume);
      return (<div>{getDecimalFormat(totalVolume)} lts</div>);
    }
  },
  {
    Header: 'Volumen Actual',
    Cell: ({ original }) => {
      const currentVolume = parseFloat(original.currentVolume);
      return (<div>{getDecimalFormat(currentVolume)} lts</div>);
    }
  },
  {
    Header: 'Porcentaje Fisico',
    Cell: ({ original }) => (<UpdatePercentageComponent data={original} keyInventory={inventoryDictionary.local} />)

  },
  {
    Header: 'Total KG',
    Cell: ({ original }) => {
      return (
        <div>
          {original.totalKg !== undefined && (original.totalKg !== 0)
            ? getDecimalFormat(original?.totalKg)
            : "0.00"}{" "}
          kg
        </div>
      )
    }
  },
]

export const columnsStation_digital = (inventoryType, keyInventory, edited) => {
  return [
    {
      Header: 'Unidad',
      accessor: 'number',
      filterable: true,
      filterMethod: (filter, row) => row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
      // Cell: () => {}
    },
    {
      Header: 'Volumen Total',
      accessor: 'totalVolume',
      Cell: ({ original }) => (<div>{original.totalVolume} lts</div>),
      filterable: true,
      filterMethod: (filter, row) =>
        row.totalVolume?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
    },
    {
      Header: 'Volumen Actual',
      accessor: 'currentVolume',
      Cell: ({ original }) => (<div>{original.currentVolume} lts</div>),
      filterable: true,
      filterMethod: (filter, row) =>
        row.currentVolume?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
    },
    {
      Header: 'Porcentaje Digital',
      accessor: 'currentPercentage',
      filterable: true,
      filterMethod: (filter, row) =>
        row.currentPercentage?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
    },
    {
      Header: 'Total kilos',
      accessor: 'totalKg',
      Cell: ({ original }) => (
        <div>
          {original.totalKg !== undefined && (original.totalKg !== 0)
            ? original?.totalKg?.toFixed(2)
            : "0.00"}{" "}
          kg
        </div>
      ),
      filterable: true,
      filterMethod: (filter, row) =>
        row.totalKg?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
    },
    {
      Header: "Fecha sync",
      accessor: "syncDate",
      filterable: true,
      filterMethod: (filter, row) =>
        row.syncDate?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
    },
    {
      Header: "Acciones",
      Cell: ({ original }) => (
        <InventoriesActions
          original={original}
          inventoryType={inventoryType}
          keyInventory={keyInventory}
          edited={edited}
        />
      )
    }
  ]
}
